import React, { useState } from 'react';
import './styles.css';
import { HambergerMenu, CloseCircle } from 'iconsax-react';
import { global } from '../../../../global';
import SideBar from '../sideBar';
import ChangeLanguage from '../changeLanguage';
import JoinTheClub from '../joinTheClub';
import { NavLink } from "react-router-dom";
import MenuSideBarHome from '../../../home/components/MenuSideBar';
import { useNavigate } from 'react-router-dom';
import HeaderSession from '../headerSession';
const {
  logos: {
    wellezyLogo
  }
} = global.img;

function Header() {
  const [isShowerSideBar, setIsShowerSideBar] = useState(false);
  const navigate = useNavigate();
  const navBarList = [
    { text: 'Travel', url: '/fligths' },
    // { text: 'Nosotros', url: '/aboutus' },
    // { text: 'Especialidades y Servicios', url: '/#' },
    { text: 'Arma Tu Paquete', url: 'https://wa.link/640gfp' },
  ]

  function goToOptionMenu(screen) {
    const urlPattern = /^(https?:\/\/)?([\w.]+)\.([a-z]{2,})(\/[\w .-]*)*\/?$/i;
    const extarnalURL = urlPattern.test(screen);
    extarnalURL
      ? window.location.href = screen
      : navigate(`${screen}`, {})
  }


  return (
    <>
      <SideBar open={isShowerSideBar} close={setIsShowerSideBar} width={400} child={
        <MenuSideBarHome clearSideBar={setIsShowerSideBar} />} />
      <div className='headerContainerWrap'>
        <div className='headerContainer'>
          <div className='headerContainerLeft'>
            <div className='headerMenu' onClick={() => setIsShowerSideBar(!isShowerSideBar)}>
              {isShowerSideBar
                ? <CloseCircle size="32" color="#FFFFFF" />
                : <HambergerMenu size="32" color="#FFFFFF" />
              }
            </div>
            <NavLink to="/">
              <div className='headerLogo'>
                <img src={wellezyLogo} alt='logo-wellezy' className='headerLogoImg' />
              </div>
            </NavLink>
          </div>

          <div className='headerContainerRight'>
            <div className='navbarTextContainer'>
              {
                navBarList.map((index, key) => {
                  const isActive = window.location.pathname === index?.url;
                  return (
                    <div key={key} className={`navBarOption ${isActive ? 'navBarOptionActive' : ''}`} onClick={() => goToOptionMenu(index?.url)}>
                      <p className='navBarOptionText'>{index.text}</p>
                    </div>
                 )
                })
              }
            </div>
            <JoinTheClub />
            <ChangeLanguage />
            <HeaderSession/>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header;
